/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentStatePolicy,
  AgentStatePolicy$Outbound,
  AgentStatePolicy$outboundSchema,
} from "./agentstatepolicy.js";
import {
  AgentStateTool,
  AgentStateTool$Outbound,
  AgentStateTool$outboundSchema,
} from "./agentstatetool.js";
import {
  AgentStateUpdate,
  AgentStateUpdate$Outbound,
  AgentStateUpdate$outboundSchema,
} from "./agentstateupdate.js";
import {
  AgentStateVersions,
  AgentStateVersions$Outbound,
  AgentStateVersions$outboundSchema,
} from "./agentstateversions.js";

export type ReportStateRequestBody = {
  /**
   * Versions of the device agent's binaries and the platform they run on.
   */
  agent: AgentStateVersions;
  /**
   * Start of the window tools[].drift_corrections counts over (the daemon's start).
   */
  driftCountingSince?: Date | undefined;
  /**
   * True when the kill switch has halted policy enforcement because the running build is in blocked_versions. The tool outcomes are then those of the last reconcile before the halt.
   */
  enforcementHalted: boolean;
  /**
   * When the agent assembled the report, by its own clock.
   */
  generatedAt: Date;
  /**
   * The policy the agent's last reconcile applied.
   */
  policy: AgentStatePolicy;
  /**
   * Report envelope version. Fields are added within a version; a change of meaning bumps it. Newer versions are accepted and stored as far as this server understands them.
   */
  schemaVersion: number;
  /**
   * Each managed tool's outcome from the last reconcile.
   */
  tools: Array<AgentStateTool>;
  /**
   * The device agent's update posture.
   */
  update?: AgentStateUpdate | undefined;
};

/** @internal */
export type ReportStateRequestBody$Outbound = {
  agent: AgentStateVersions$Outbound;
  drift_counting_since?: string | undefined;
  enforcement_halted: boolean;
  generated_at: string;
  policy: AgentStatePolicy$Outbound;
  schema_version: number;
  tools: Array<AgentStateTool$Outbound>;
  update?: AgentStateUpdate$Outbound | undefined;
};

/** @internal */
export const ReportStateRequestBody$outboundSchema: z.ZodMiniType<
  ReportStateRequestBody$Outbound,
  ReportStateRequestBody
> = z.pipe(
  z.object({
    agent: AgentStateVersions$outboundSchema,
    driftCountingSince: z.optional(
      z.pipe(z.date(), z.transform(v => v.toISOString())),
    ),
    enforcementHalted: z.boolean(),
    generatedAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    policy: AgentStatePolicy$outboundSchema,
    schemaVersion: z.int(),
    tools: z.array(AgentStateTool$outboundSchema),
    update: z.optional(AgentStateUpdate$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      driftCountingSince: "drift_counting_since",
      enforcementHalted: "enforcement_halted",
      generatedAt: "generated_at",
      schemaVersion: "schema_version",
    });
  }),
);

export function reportStateRequestBodyToJSON(
  reportStateRequestBody: ReportStateRequestBody,
): string {
  return JSON.stringify(
    ReportStateRequestBody$outboundSchema.parse(reportStateRequestBody),
  );
}
